import { ContentContainer } from "@twinkltech/curriculum-architect-component-library";
import { Button, Text } from "@twinkltech/web-ui";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { paths } from "@/paths";

import NotFoundImage from "./assets/image.png";
import { GENERIC_ERROR_NS } from "./GenericError.i18n";

export const GenericError = () => {
  const { t } = useTranslation(GENERIC_ERROR_NS);
  return (
    <ContentContainer className="max-w-[1240px] mx-0!">
      <div className="mb-16">
        <Text
          as="h1"
          className="gradient-header font-bold max-w-[450px] mb-2"
          variant="5xl-bold"
        >
          <Trans
            i18nKey="generic-error.title"
            ns={GENERIC_ERROR_NS}
            values={{
              br: <br />,
            }}
          />
        </Text>
      </div>
      <div className="flex gap-4">
        <div className="flex flex-col gap-10 grow">
          <Text as="p" className="max-w-[416px]" variant="lg-normal">
            <Trans
              components={{
                Link: (
                  <a
                    className="underline text-blue-500 hover:text-blue-600"
                    href={paths.external.CUSTOMER_SUPPORT_URL}
                  />
                ),
              }}
              i18nKey="generic-error.message"
              ns={GENERIC_ERROR_NS}
            />
          </Text>
          <div>
            <Button as={Link} to={paths.EXPLORE_SCHEME_LIST_CONTENTS_PATH}>
              {t("navigate-to-text")}
            </Button>
          </div>
        </div>
        <div>
          <img
            alt={t("not-found-image-alt")}
            className="max-w-[339px]"
            src={NotFoundImage}
          />
        </div>
      </div>
    </ContentContainer>
  );
};
